export function initAccessibilityTrigger() {
    $("[data-acsb='trigger']").click(function () {
      var loaded = sessionStorage.getItem('acsb_loaded');
      if (loaded) return; // Prevent multiple reloads
  
      sessionStorage.setItem('acsb_loaded', true);
      window.location.href = window.location.href + '#showacsb';
      document.location.reload(); // Reload page to apply accessibility settings
    });
  }